import { render, staticRenderFns } from "./TravelProDes.vue?vue&type=template&id=c3e189d6&scoped=true"
import script from "./TravelProDes.vue?vue&type=script&lang=js"
export * from "./TravelProDes.vue?vue&type=script&lang=js"
import style0 from "./TravelProDes.vue?vue&type=style&index=0&id=c3e189d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e189d6",
  null
  
)

export default component.exports